import { render, staticRenderFns } from "./FormSuspend.vue?vue&type=template&id=125c0326&scoped=true"
import script from "./FormSuspend.vue?vue&type=script&lang=js"
export * from "./FormSuspend.vue?vue&type=script&lang=js"
import style0 from "./FormSuspend.vue?vue&type=style&index=0&id=125c0326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125c0326",
  null
  
)

export default component.exports